export const icons = {
  rules: 'instructions-icon.png',
  minuta: 'sheet.png',
  'draft-plan': 'plan-draft.svg',
  'executive-plan': 'plan-final.svg',
  'actions-portfolio': 'actions-portfolio-icon.png',
  'draft-response': 'mail-unread.svg',
  'final-results': 'final-report-icon.png',
};
